import { useId } from "react";

export const LogoMark = ({ size = 40, halo = "#FDFBF7", className = "" }) => {
  const clip = useId();
  const a = "M5 30 C 13 8, 20 8, 24 24 S 35 40, 43 18";
  const b = "M5 18 C 13 40, 20 40, 24 24 S 35 8, 43 30";
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className} aria-hidden="true">
      <defs>
        <clipPath id={clip}>
          <rect x="18" y="12" width="12" height="24" />
        </clipPath>
      </defs>
      <path d={b} stroke="#D9A05B" strokeWidth="4.5" strokeLinecap="round" />
      <path d={a} stroke={halo} strokeWidth="8.5" strokeLinecap="round" />
      <path d={a} stroke="#C85A32" strokeWidth="4.5" strokeLinecap="round" />
      <g clipPath={`url(#${clip})`}>
        <path d={b} stroke={halo} strokeWidth="8.5" />
        <path d={b} stroke="#D9A05B" strokeWidth="4.5" />
      </g>
    </svg>
  );
};

export const Logo = ({ light = false, halo, size = 36, testId = "woven-logo" }) => (
  <span data-testid={testId} className="inline-flex items-center gap-2.5">
    <LogoMark size={size} halo={halo ?? (light ? "#2C221E" : "#FDFBF7")} />
    <span className={`font-serif text-2xl font-medium tracking-tight ${light ? "text-[#FDFBF7]" : "text-[#2C221E]"}`}>
      Woven
    </span>
  </span>
);
